import { PdVideoConfig } from '../../interfaces/programs.interfaces';

export const GRAMMAR_PD_VIDEO_CONTENT: PdVideoConfig[] = [
    {
        mediaId: '4ac8a6e9-47b1-4de9-834f-42f4749ef046',
        content: [
            'In this first PD video, you will learn the three pillars of the EB Grammar Framework:',
            {
                innerHtml: true,
                text: `
              <ul><li>Direct Instruction</li></ul>
              <ul><li>Games</li></ul>
              <ul><li>Application to Writing</li></ul>
              `,
            },
            'Grammar can certainly be tough to teach, but by following this simple and effective framework, your students will become confident, skilled writers and communicators who naturally apply grammar rules to their writing.',
        ],
    },
    {
        mediaId: '24b6e2bc-a2b6-4168-9c54-ee3732153cab',
        content: [
            'This video is all about unlocking the secrets of grammar through mastering direct instruction. Direct Instruction is the first pillar of the EB Grammar Framework, and this PD video walks you through the three components of this pillar:',
            {
                innerHtml: true,
                text: `
            <ul><li>Make it interactive</li></ul>
            <ul><li>Scaffold the learning</li></ul>
            <ul><li>Connect it to real life</li></ul>
            `,
            },
        ],
    },
    {
        mediaId: 'a879f0a2-a278-482a-bc46-da2288cf4bc8',
        content: [
            'This video is all about gamifying your grammar lessons. Games are the second pillar of the EB Grammar Framework and can be a powerful tool for reinforcing grammar skills. This PD video discusses the benefits of using games in the classroom to help students nail down grammar concepts.',
        ],
    },
    {
        mediaId: '6f1fbb5f-611b-4b3a-a913-dbac69dafd0d',
        downloadUrl: '/program-content/EBGP_Certificate_of_Completion.pdf',
        content: [
            'In this final video, you will learn how to help your students apply their grammar knowledge to their writing. Application to Writing is the third pillar of the EB Grammar Framework, and this video guides you through integrating grammar instruction with writing.',
            'After watching this final video, click the button below to download your Grammar PD Certificate of Completion.',
        ],
    },
];
